if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('#AgreeToTos');
      const container = this.closest('.cart__details, .sidebar__footer');
      this.button = container?.querySelector('#CheckOut');

      if (this.checkbox && this.button) {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.#toggleCheckoutButton();

        this.checkbox.addEventListener('change', () => {
          this.#toggleCheckoutButton();
          this.classList.remove('terms-checkbox--invalid', 'terms-checkbox--shake');
          this.checkbox.removeAttribute('aria-invalid');
        }, options);

        this.button.addEventListener('click', event => {
          this.#validateCheckout(event);
        }, options);

        this.button.form?.addEventListener('submit', event => {
          if (!event.submitter || event.submitter === this.button) {
            this.#validateCheckout(event);
          }
        }, options);
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    #toggleCheckoutButton() {
      // Keep the blocked button interactive so mouse, touch and keyboard can show the hint.
      this.button.disabled = false;
      this.button.setAttribute('aria-disabled', String(!this.checkbox.checked));
    }

    #validateCheckout(event) {
      if (this.checkbox.checked) return;

      event.preventDefault();
      this.classList.add('terms-checkbox--invalid');
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.checkbox.focus({ preventScroll: true });
      this.scrollIntoView({ block: 'nearest' });

      this.classList.remove('terms-checkbox--shake');
      // Restart the animation for every checkout attempt.
      void this.offsetWidth;
      this.classList.add('terms-checkbox--shake');
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
